(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zg-showroom-trust"] && !Shopify.designMode) return;
  try {
    if (!window.zgLocalDrawerBound) {
  window.zgLocalDrawerBound = true;
  const states = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function closeDrawer(dialog) {
    const state = states.get(dialog);
    if (!state || !dialog.open || dialog.dataset.phase === 'closing') return;
    cancelAnimationFrame(state.frame);
    dialog.querySelector('video')?.pause();
    dialog.dataset.phase = 'closing';
    const finish = () => {
      clearTimeout(state.timer);
      if (dialog.dataset.phase === 'closing') dialog.close();
    };
    if (reducedMotion.matches) finish();
    else state.timer = setTimeout(finish, 480);
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-zg-open]');
    if (opener) {
      const dialog = opener.closest('.zg-team')?.nextElementSibling;
      if (!dialog?.matches('.zg-local-drawer')) return;
      let state = states.get(dialog);
      if (!state) {
        state = {};
        states.set(dialog, state);
        dialog.addEventListener('cancel', event => {
          event.preventDefault();
          closeDrawer(dialog);
        });
        dialog.addEventListener('transitionend', event => {
          if (event.target === dialog && !event.pseudoElement && event.propertyName === 'transform' && dialog.dataset.phase === 'closing') {
            clearTimeout(state.timer);
            dialog.close();
          }
        });
        dialog.addEventListener('close', () => {
          clearTimeout(state.timer);
          cancelAnimationFrame(state.frame);
          delete dialog.dataset.phase;
          dialog.querySelector('video')?.pause();
          if (state.opener?.isConnected) state.opener.focus({ preventScroll: true });
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer(dialog);
        });
      }
      state.opener = opener;
      clearTimeout(state.timer);
      cancelAnimationFrame(state.frame);
      if (!dialog.open) dialog.showModal();
      if (reducedMotion.matches) dialog.dataset.phase = 'open';
      else state.frame = requestAnimationFrame(() => {
        state.frame = requestAnimationFrame(() => { if (dialog.open) dialog.dataset.phase = 'open'; });
      });
    }
    const closer = event.target.closest('[data-zg-close]');
    if (closer) closeDrawer(closer.closest('.zg-local-drawer'));
  });
}
  } catch(e) { console.error(e); }
})();

})();
